import React from 'react';
import { PaidInvoicesTable } from '../PaidInvoicesTable/PaidInvoicesTable';
import { CanceledInvoicesTable } from '../CanceledInvoicesTable/CanceledInvoicesTable';

export const HistoryInvoices = () => (
  <div className='mb-[32px]'>
    <PaidInvoicesTable />
    <CanceledInvoicesTable />
  </div>
);
